<template>
  <div class="tabs-common tabs-names">
    <div class="block_1">
      <p class="common-title">Applicant Details</p>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant TIN</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.tin" placeholder="Applicant TIN">
          <label>Applicant TIN</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant RC Number</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.rc_number" placeholder="Applicant RC Number">
          <label>Applicant RC Number</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant's State Code</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.state_code" maxlength="50" placeholder="Applicant's State Code">
          <label>Applicant's State Code</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant's City</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.app_city" max="20" placeholder="Applicant's City">
          <label>Applicant's City</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant Name</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.app_name" maxlength="50" placeholder="Applicant Name">
          <label>Applicant Name</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant Address</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control"
                 v-model="tab_data.app_address" maxlength="60" placeholder="Applicant Address">
                 <label>Applicant Address</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant's Fax</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.app_fax" maxlength="20" placeholder="Applicant's Fax">
          <label>Applicant's Fax</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant's Phone</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.app_phone" maxlength="20" placeholder="Applicant's Phone">
          <label>Applicant's Phone</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Applicant's Email</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.app_email" maxlength="40" placeholder="Applicant's Email">
          <label>Applicant's Email</label>
        </div>
      </div>
      <p class="common-title">Beneficiary Details</p>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Beneficiary Name</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bnf_name" maxlength="50" placeholder="Beneficiary Name">
          <label>Beneficiary Name</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Beneficiary Address</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control"
                 v-model="tab_data.bnf_address" maxlength="60" placeholder="Beneficiary Address">
                 <label>Beneficiary Address</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Beneficiary Country</label> -->
        <div class="col-sm-10">
          <NewSelectWrapper type="country" v-model="tab_data.bnf_country" placeholder="Beneficiary Country"/>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Beneficiary Phone</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bnf_phone" maxlength="20" placeholder="Beneficiary Phone">
          <label>Beneficiary Phone</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Beneficiary Fax</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bnf_fax" maxlength="20" placeholder="Beneficiary Fax">
          <label>Beneficiary Fax</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Beneficiary Email</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bns_email" maxlength="20" placeholder="Beneficiary Email">
          <label>Beneficiary Email</label>
        </div>
      </div>
    </div>
    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'" @click="page_change('Header',0)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('Transport',2)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import NewSelectWrapper from './../../fields/NewSelectWrapper.vue'
import NewDatepickerWrapper from './../../fields/NewDatepickerWrapper.vue'
export default {
  name: 'tabs-names',
  props: ['cur_tab_name', 'indata'],
  data() {
    return {
      tab_data: {
        tin: '',
        rc_number: 0,
        state_code: '',
        app_city: '',
        app_name: '',
        app_address: '',
        app_fax: '',
        app_phone: '',
        app_email: '',
        bnf_name: '',
        bnf_address: '',
        bnf_country: '',
        bnf_phone: '',
        bnf_fax: '',
        bns_email: '',
      }
    }
  },
  components: {
    NewSelectWrapper,
    NewDatepickerWrapper
  },
  mixins: [common],
  methods: {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tabs-names{
  background-color: transparent;
  padding: 0;
  // .block_1 {
  //   background-color: #fff;
  //   border-radius: 20px;
  //   padding: 24px;
  //   margin-bottom: 20px;
  // }

  // .block_2 {
  //   padding-bottom: 60px;
  // }
}
</style>
